import request from '@/utils/request';

/**
 * 列表
 */
export function getTempLists() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/templates',
    method: 'GET',
    params: pram
  });
}

/**
 * 创建默认小程序模板关系
 */
export function createTemplate() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/createTemplate',
    method: 'post',
    params: params
  });
}

/**
 * 保存模板设置
 */
export function saveTemplateSettings() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/saveTemplateSettings',
    method: 'post',
    data: data
  });
}

/**
 *发送消息
 */
export function sendOrderMsg() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/send-notification',
    method: 'post',
    params: params
  });
}